const BASE_URL = process.env.REACT_APP_CORE_API || "";

export const BFAPI_URL = process.env.REACT_APP_BFAPI || "";

export const NOVEMBER_URL = process.env.REACT_APP_WAREHOUSE_API || "";

export default BASE_URL;
